var React = require('react');

function Circle4Inline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"74.9941","cy":"75.5","r":"59.8027","stroke":"white","strokeOpacity":"0.35","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"75.5","cy":"75.5","r":"74.5","stroke":"white","strokeOpacity":"0.1","strokeWidth":"2","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.732 26.1373H23.4432L13.0436 41.0617H16.7475V36.7194H24.5847V41.0617H28.3796V47.8042H24.5847V52.6938H16.5286V47.8042H3.02734V42.427L14.732 26.1373ZM15.2518 27.1509L4.04095 42.7534V46.7906H17.5422V51.6802H23.5711V46.7906H27.366V42.0753H23.5711V37.733H17.7611V42.0753H11.1019L21.5015 27.1509H15.2518Z","fill":"white","key":2})]);
}

Circle4Inline.defaultProps = {"className":"cirecle-outline","width":"151","height":"151","viewBox":"0 0 151 151","fill":"none"};

module.exports = Circle4Inline;

Circle4Inline.default = Circle4Inline;
